import { App } from './app'
import 'firebase/auth'

export const Auth = App.auth()
